module.exports = __webpack_public_path__ + "fonts/fa-regular-400.c3b7902.woff";